<template>
	<div
		class="chapter-item"
		@click="router.push({ name: 'ChapterPage', params: { page: page } })"
	>
		<p class="chapter-item__title">{{ name }}</p>
		<div class="chapter-item__image">
			<svg>
				<use :xlink:href="`sprite.svg#${icon}`"></use>
			</svg>
		</div>
		<div class="chapter-item__button">
			<button>Перейти в раздел</button>
			<svg width="20" height="20">
				<use xlink:href="sprite.svg#arrow-right"></use>
			</svg>
		</div>
	</div>
</template>

<script setup>
import { useRouter } from 'vue-router';

const router = useRouter();

defineProps({
	name: {
		type: String,
		required: true,
	},
	icon: {
		type: String,
		required: true,
	},
	page: {
		type: String,
		required: true,
	},
});
</script>

<style lang="scss">
@import './EpkChapter.scss';
</style>
